import React from 'react';
import {CloseSharp} from '@material-ui/icons';
import {useTranslation} from 'react-i18next';
import {BORDER_COLOR, DEFAULT_WHITE_COLOR} from 'src/style/variable';
import {
  makeStyles,
  Drawer,
  Theme,
  IconButton,
  Typography,
  Button
} from '@material-ui/core';
import './FilterDrawerComponent.scss';

const DrawerStyles = makeStyles((theme: Theme) => ({
  drawer: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent'
    },
    '& .MuiDrawer-paperAnchorRight': {
      minWidth: '300px',
      backgroundColor: DEFAULT_WHITE_COLOR,
      zIndex: 1100,
      borderLeft: `1px solid ${BORDER_COLOR}`,
      paddingTop: theme.mixins.toolbar.minHeight
    },
    '& .MuiPaper-elevation16': {
      boxShadow: 'none'
    }
  }
}));

interface FilterDrawerComponentProps {
  open: boolean;
  title: string;
  drawerClass?: any;
  drawerWidth?: number | string;
  onClose?(reason?: string): void;
  // resetFilter?(): void;
  onResetFilter?(): void;
  // applyFilter?(): void;
  onApplyFilter?(): void;
}
const FilterDrawerComponent: React.FC<FilterDrawerComponentProps> = props => {
  const {
    open,
    title,
    onClose,
    children,
    onApplyFilter,
    onResetFilter,
    drawerClass,
    drawerWidth = 300
  } = props;
  const drawerClasses = DrawerStyles();
  const {t} = useTranslation();

  const handleClose = React.useCallback(() => {
    if (typeof onClose === 'function') {
      onClose();
    }
  }, [onClose]);

  const handleApplyFilter = React.useCallback(() => {
    if (typeof onApplyFilter === 'function') {
      onApplyFilter();
    }
  }, [onApplyFilter]);

  const handleResetFilter = React.useCallback(() => {
    if (typeof onResetFilter === 'function') {
      onResetFilter();
    }
  }, [onResetFilter]);

  return (
    <Drawer
      disableEnforceFocus
      className={[drawerClasses.drawer, 'filter-drawer-component-wrapper'].join(
        ' '
      )}
      anchor={'right'}
      open={open}
      PaperProps={{
        style: {minWidth: drawerWidth}
      }}
      onClose={handleClose}>
      <div
        className={[
          'filter-drawer-component-container',
          drawerClass ? drawerClass : ''
        ].join(' ')}>
        <div
          className={'filter-drawer-title-section'}
          data-test-id="pcl-appointments-filterPopup">
          <div className={'filter-drawer-title'}>
            <Typography variant="h3">{title || t('COMMON.FILTER')}</Typography>
          </div>
          <IconButton onClick={handleClose}>
            <CloseSharp
              className={'close-icon'}
              data-test-id="pcl-appointments-notificationCloseIcon"
            />
          </IconButton>
        </div>
        <div className={'filter-drawer-content-section'}>{children}</div>
        <div className="filter-drawer-action-section">
          <Button
            data-test-id="pcl-appointments-notificationReset"
            variant="outlined"
            color="primary"
            onClick={handleResetFilter}>
            {t('COMMON.FILTER_SCREEN.RESET')}
          </Button>
          <Button
            data-test-id="pcl-appointments-notificationApply"
            variant="contained"
            color="primary"
            onClick={handleApplyFilter}>
            {t('COMMON.FILTER_SCREEN.APPLY')}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default FilterDrawerComponent;
